import React, { useEffect } from 'react';
import { Fabric } from 'office-ui-fabric-react/lib/Fabric';
import { Welcome } from 'containers';
import { gtmTrackPage } from 'utils/GTM/GTMUtil';
import { gaPageTrackTags } from 'utils/GTM/GATags';
import { checkIsLoggedIn } from 'utils/CommonUtil';

const LandingPage = props => {
	useEffect(() => {
		gtmTrackPage(gaPageTrackTags.welcomePage);
		checkIsLoggedIn(props);
	}, [props]);

	return (
		<Fabric>
			<Welcome {...props} />
		</Fabric>
	);
};

export default LandingPage;
